class TipoDirecionamentoEnum {
  constructor() {
    this.MARKETPLACE = 1;
    this.TRANSPORTADORA = 2;
  }

  getTiposLabel() {
    return [
      { label: 'Marketplace', value: this.MARKETPLACE },
      { label: 'Transportadora', value: this.TRANSPORTADORA },
    ];
  }

  getTipo(tipoDirecionamento) {
    return this.getTiposLabel()
      .filter(label => label.value === tipoDirecionamento)
      .shift();
  }
}

export default new TipoDirecionamentoEnum();
